// Returns the text for the first activity item,
// "Customer added" or "Added from {source}".
export default function getFirstActivityText({ customer }) {
  const hasLeadSource = !!customer.lead?.source;

  if (hasLeadSource) {
    const sourceName = getLeadSourceName(customer.lead.source);
    return `Added from ${sourceName}`;
  } else
    return getNewCustomerText({ customer });
}


function getNewCustomerText({ customer }) {
  const { provider } = customer;

  if (provider)
    return `Contact added by ${provider.name}`;
  else
    return 'Contact added';
}


function getLeadSourceName(source) {
  const sources = {
    facebook: 'Facebook',
    gmb:      'Google',
    sms:      'SMS',
    webchat:  'Web Chat',
    website:  'Contact Form',
    yelp:     'Yelp',
    other:    'external source'
  };

  return sources[source] || 'Contact Form';
}
